import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-detail-installment',
  templateUrl: './modal-detail-installment.component.html',
  styleUrls: ['./modal-detail-installment.component.scss']
})
export class ModalDetailInstallmentComponent implements OnInit {

  modalData: any;
  listData: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalDetailInstallmentComponent>,
    private fb: FormBuilder,
  ) {
    this.modalData = data;
  }

  ngOnInit(): void {
    // console.log(this.modalData);
    this.listData = this.modalData.detail
  }

  closeModal() {
    const response = {
      status: false
    }
    // // console.log(response);
    this.dialogRef.close(response);
  }

  invoice(id, ver) {
    window.open(`/accounting/create-invoice?isEdit=true&id=${id}&Partial=true&version=${ver}`, '_blank');
  }

}
